<template>
  <DetailsModal v-if="showModal" :name="modalName" :badges-list="selectedPrice?.badgesList" @close="closeModal" />
  <PerkContainer
    v-if="offers.giftOffer?.mainOffer && !((isGWPEnabled || isGWPEnabled2) && selectedPrice.isGWPAvailable)"
    data-test-id="gwp-perk"
    :icon="offers.giftOffer.icon"
    :type="offers.giftOffer.type"
    is-raw-clickable
    @value-info-click="toggleDetailsModal"
  >
    <div class="promotion-perk">
      <div class="promotion large">
        {{ offers.giftOffer.mainOffer }}
      </div>
      <div class="see-more">
        {{ offers.giftOffer.moreDetails }}
      </div>
    </div>
  </PerkContainer>
  <PerkContainer
    v-if="offers.otherOffer?.mainOffer"
    is-raw-clickable
    :icon="offers.otherOffer.icon"
    :type="offers.otherOffer.type"
    @value-info-click="toggleDetailsModal"
  >
    <div class="promotion-perk">
      <div class="promotion large">
        {{ offers.otherOffer.mainOffer }}
      </div>
      <div class="see-more">
        {{ offers.otherOffer.moreDetails }}
      </div>
    </div>
  </PerkContainer>
  <PerkContainer
    v-if="isBcom && offers.loyallistOffer?.mainOffer"
    is-raw-clickable
    icon="loyallist-small"
    type="loyalty"
    @value-info-click="toggleDetailsModal"
  >
    <div class="loyallist-perk">
      <div class="loyallist large">
        {{ offers.loyallistOffer.mainOffer }}
      </div>
    </div>
  </PerkContainer>
</template>

<script setup>
import { provide, ref } from 'vue';
import DetailsModal from '@nuxt-common/media-card-large/app/modules/price/components/DetailsModal';
import { PRICE_OVERLAY_DATA } from '@nuxt-common/media-card-large/app/modules/price/components/constants';
import { PRICE_OVERLAY_DATA as PRICE_OVERLAY_DATA_BCOM } from '@nuxt-common/media-card-large/app/modules/price/components/bcom/constants';
import PerkContainer from '~/modules/productPerks/components/PerkContainer';
import { useBrand } from '~/composables/useBrand';
import useExperiments from '~/stores/useExperimentsStore';
import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import usePromotionPerks from '~/modules/productPerks/composables/usePromotionPerks';
import once from '~/utils/once';
import { gwpPromotionClick, loyaltyPromotionClick, otherPromotionClick } from '~/features/analytics/productPerks';

const selectedPrice = useProductPrice();
const { offers } = usePromotionPerks();

const { isBcom } = useBrand();
const {
  experimentFlags: { isGWPEnabled, isGWPEnabled2 },
} = useExperiments();

const showModal = ref(false);
const modalName = 'price-section-detail-modal';

const fireGwpAnalytics = once(gwpPromotionClick);
const fireLoyaltyAnalytics = once(loyaltyPromotionClick);
const fireAnalytics = once(otherPromotionClick);

provide(isBcom ? PRICE_OVERLAY_DATA_BCOM : PRICE_OVERLAY_DATA, selectedPrice);

const toggleDetailsModal = (type) => {
  if (type === 'gwp') fireGwpAnalytics();
  else if (type === 'loyalty') fireLoyaltyAnalytics();
  else fireAnalytics();

  showModal.value = true;
};
const closeModal = () => {
  showModal.value = false;
};
</script>

<style lang="scss" scoped>
.promotion-perk,
.loyallist-perk {
  overflow: hidden;
}

.loyallist,
.promotion {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-clamp: 1;
}

.promotion {
  margin-bottom: rem-calc(4);
}
.see-more {
  color: $gray-1-color;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
